/**
 * Guideline Daily Amount (GDA) — EU Reference Intake values for an average
 * adult, used on packaged-food nutrition labels across the EU/UK. Values come
 * from EU Regulation 1169/2011 Annex XIII (calories, fat, carbs, protein) and
 * SACN's 2015 carbohydrate report (fibre).
 */
export const GDA = {
  caloriesKcal: 2000,
  proteinG: 50,
  carbsG: 260,
  fatG: 70,
  fiberG: 30,
} as const;

export function gdaPct(value: number, total: number): number {
  if (!Number.isFinite(value) || total <= 0) return 0;
  return Math.round((value / total) * 100);
}
